import React, { Component } from "react"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../translates/translate"


/* Component Layout */
class Layout extends Component {

    /* Draw button */
    _button = () => {

        const { reload } = this.props

        if (reload) {
            return <div onClick={() => reload()} className="button">{t("layout.retry")}</div>
        }
    }

    render = () => {

        const { status } = this.props

        if (status === "empty") {
            return (
                <div className="inner-layout-box">
                    <img src="/images/empty.png" alt="Empty" style={{ filter: "invert(0)" }} />
                    <h2>{t("layout.empty")}</h2>
                    <p>{t("layout.emptyDesc")}</p>
                </div>
            )
        }

        if (status === "error") {
            return (
                <div className="inner-layout-box">
                    <img src="/images/alert.png" alt="Alert" />
                    <h2>{t("layout.serverError")}</h2>
                    <p>{t("layout.serverErrorDesc")}</p>
                    {this._button()}
                </div>
            )
        }

        if (status === "network") {
            return (
                <div className="inner-layout-box">
                    <img src="/images/wifi.png" alt="Wifi" />
                    <h2>{t("layout.networkError")}</h2>
                    <p>{t("layout.networkErrorDesc")}</p>
                    {this._button()}
                </div>
            )
        }

        if (status === "permission") {
            return (
                <div className="inner-layout-box">
                    <img src="/images/user-key.png" alt="User Key" />
                    <h2>{t("layout.noAccess")}</h2>
                    <p>{t("layout.noAccessDesc")}</p>
                    {this._button()}
                </div>
            )
        }

        if (status === "key") {
            return (
                <div className="inner-layout-box">
                    <img src="/images/key.png" alt="Key" />
                    <h2>{t("layout.invalidKey")}</h2>
                    <p>{t("layout.invalidKeyDesc")}</p>
                    <div onClick={() => window.location.reload()} className="button">{t("layout.reload")}</div>
                </div>
            )
        }

        return (
            <div className="inner-layout-box">
                <LoadingOutlined />
            </div>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        language: state.language,
    }
}

export default connect(mapStateToProps)(Layout)
